export default {
  productQuantity: [
    { objectID: '5357011', quantity: 1 },
    { objectID: '5354101', quantity: 1 },
    { objectID: '4494401', quantity: 1 },
    { objectID: '4494000', quantity: 1 },
  ],
  products: {
    '4494000': {
      name: 'Amazon - Case for Amazon Fire HD 8 Tablets - Black',
      description: "Take your Amazon Fire HD 8 tablet on the go with this Amazon B00XM5W2WE case, which features a folio cover that guards your device's display and automatically wakes up your device when opened. The built-in stand offers comfortable hands-free viewing.",
      brand: 'Amazon',
      categories: ['Computers & Tablets', 'iPad & Tablet Accessories', 'Cases'],
      hierarchicalCategories: {
        lvl0: 'Computers & Tablets',
        lvl1: 'Computers & Tablets > iPad & Tablet Accessories',
        lvl2: 'Computers & Tablets > iPad & Tablet Accessories > Cases',
      },
      price: 39.99,
      price_range: '1 - 50',
      image: 'https://cdn-demo.algolia.com/bestbuy/4494000_sb.jpg',
      free_shipping: false,
      rating: 6,
      objectID: '4494000',
      _snippetResult: {
        description: {
          value: 'Take your Amazon Fire HD 8 tablet on the go',
          matchLevel: 'none',
        },
      },
      _highlightResult: {
        name: {
          value: 'Amazon - Case for Amazon Fire HD 8 Tablets - Black',
          matchLevel: 'none',
          matchedWords: [],
        },
        description: {
          value: "Take your Amazon Fire HD 8 tablet on the go with this Amazon B00XM5W2WE case, which features a folio cover that guards your device's display and automatically wakes up your device when opened. The built-in stand offers comfortable hands-free viewing.",
          matchLevel: 'none',
          matchedWords: [],
        },
      },
    },
    '4494401': {
      name: 'Amazon - Case for Amazon Fire 7" Tablets - Black',
      description: 'Protect your Amazon Fire 7" tablet from scratches and bumps on the go with this slim Amazon B00ZGUYN1Q case, which features a full-coverage design with polyurethane and microfiber materials for durability. The built-in stand enables hands-free viewing.',
      brand: 'Amazon',
      categories: ['Computers & Tablets', 'iPad & Tablet Accessories', 'Cases'],
      hierarchicalCategories: {
        lvl0: 'Computers & Tablets',
        lvl1: 'Computers & Tablets > iPad & Tablet Accessories',
        lvl2: 'Computers & Tablets > iPad & Tablet Accessories > Cases',
      },
      price: 24.99,
      price_range: '1 - 50',
      image: 'https://cdn-demo.algolia.com/bestbuy/4494401_sb.jpg',
      free_shipping: false,
      rating: 4,
      objectID: '4494401',
      _snippetResult: {
        description: {
          value: 'Protect your Amazon Fire 7" tablet from scratches and bumps',
          matchLevel: 'none',
        },
      },
      _highlightResult: {
        name: {
          value: 'Amazon - Case for Amazon Fire 7" Tablets - Black',
          matchLevel: 'none',
          matchedWords: [],
        },
        description: {
          value: 'Protect your Amazon Fire 7" tablet from scratches and bumps on the go with this slim Amazon B00ZGUYN1Q case, which features a full-coverage design with polyurethane and microfiber materials for durability. The built-in stand enables hands-free viewing.',
          matchLevel: 'none',
          matchedWords: [],
        },
      },
    },
    '5354101': {
      name: '3DR - Solo Smart Rechargeable Battery - Black',
      description: '3D Robotics Battery for Solo Drones: Instead of waiting for your lone battery to recharge, get back to flying right away with this rechargeable battery for Solo drones. The battery can power your drone for up to 25 minutes with no camera attached, or 20 minutes carrying a camera.',
      brand: '3DR',
      categories: [
        'Toys, Games & Drones',
        'Drones & Accessories',
        'Drone Accessories',
        'Drone Batteries',
      ],
      hierarchicalCategories: {
        lvl0: 'Toys, Games & Drones',
        lvl1: 'Toys, Games & Drones > Drones & Accessories',
        lvl2: 'Toys, Games & Drones > Drones & Accessories > Drone Accessories',
        lvl3: 'Toys, Games & Drones > Drones & Accessories > Drone Accessories > Drone Batteries',
      },
      price: 149.95,
      price_range: '100 - 200',
      image: 'https://cdn-demo.algolia.com/bestbuy/5354101_sb.jpg',
      free_shipping: false,
      rating: 4,
      objectID: '5354101',
      _snippetResult: {
        description: {
          value: '3D Robotics Battery for Solo Drones: Instead of waiting for',
          matchLevel: 'none',
        },
      },
      _highlightResult: {
        name: {
          value: '3DR - Solo Smart Rechargeable Battery - Black',
          matchLevel: 'none',
          matchedWords: [],
        },
        description: {
          value: '3D Robotics Battery for Solo Drones: Instead of waiting for your lone battery to recharge, get back to flying right away with this rechargeable battery for Solo drones. The battery can power your drone for up to 25 minutes with no camera attached, or 20 minutes carrying a camera.',
          matchLevel: 'none',
          matchedWords: [],
        },
      },
    },
    '5357011': {
      name: '3DR - Propellers for 3DR Solo Drones (2-Pack) - Black',
      description: '3D Robotics Propellers for Solo Drones: Buy this set of replacement propellers before you need them so you can get back to flying as soon as you damage or lose a propeller. The 1-piece design of these propellers keeps them secure during flight, self-tightening so you can install them in an instant and return to in-air fun.',
      brand: '3DR',
      categories: [
        'Toys, Games & Drones',
        'Drones & Accessories',
        'Drone Accessories',
        'Drone Parts',
      ],
      hierarchicalCategories: {
        lvl0: 'Toys, Games & Drones',
        lvl1: 'Toys, Games & Drones > Drones & Accessories',
        lvl2: 'Toys, Games & Drones > Drones & Accessories > Drone Accessories',
        lvl3: 'Toys, Games & Drones > Drones & Accessories > Drone Accessories > Drone Parts',
      },
      price: 14.95,
      price_range: '1 - 50',
      image: 'https://cdn-demo.algolia.com/bestbuy/5357011_rb.jpg',
      free_shipping: false,
      rating: 2,
      objectID: '5357011',
      _snippetResult: {
        description: {
          value: '3D Robotics Propellers for Solo Drones: Buy this set of',
          matchLevel: 'none',
        },
      },
      _highlightResult: {
        name: {
          value: '3DR - Propellers for 3DR Solo Drones (2-Pack) - Black',
          matchLevel: 'none',
          matchedWords: [],
        },
        description: {
          value: '3D Robotics Propellers for Solo Drones: Buy this set of replacement propellers before you need them so you can get back to flying as soon as you damage or lose a propeller. The 1-piece design of these propellers keeps them secure during flight, self-tightening so you can install them in an instant and return to in-air fun.',
          matchLevel: 'none',
          matchedWords: [],
        },
      },
    },
  },
};
